import { lazy } from 'react';

export default {
	PlaidLink: require('./PlaidLink').default,
	StripeCard: lazy(() => import('./StripeCard')),
};
